module.exports = require("echarts");


//////////////////
// WEBPACK FOOTER
// external "echarts"
// module id = 28
// module chunks = 0